<script>
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";

import {
  getUserAccounts,
  getOrganizationAccounts,
  createUserAccount,
  createOrganizationAccount,
  patchUserAccount,
  patchOrganizationAccount,
  deleteUserAccount,
  deleteOrganizationAccount,
  resetPassword, userAccountDetail,
} from "@/service";

import _ from 'lodash';
import tableLoading from "@/views/widgets/table-loading";
import {alertComfirm} from "@/helpers/swal";
import {useVuelidate} from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";
import RoleSelect from "@/views/widgets/role-select";
import addCustomer from "@/views/user/components/add-customer.vue";
import serviceAddCustomer from "@/views/user/components/add-customer-s.vue";
import editCustomer from "@/views/user/components/edit-customer.vue";
import serviceEditCustomer from "@/views/user/components/edit-customer-s.vue";


export default {
  setup: () => ({ v$: useVuelidate() }),
  props: {
    type: {
      type: String,
      default: 'user', // user-普通用户 organization-企业用户
    },
    belong_id: {
      type: [String, Number],
      default: null,
    },
    belong_type: {
      type: String,
      default: null,
    },
    // 查看账户的权限
    getPermissionCode: {
      type: String,
      default: null,
    },
    // 编辑账户的权限
    patchPermissionCode: {
      type: String,
      default: null,
    },
    // 添加账户的权限
    postPermissionCode: {
      type: String,
      default: null,
    },
    // 冻结账户的权限
    freezePermissionCode: {
      type: String,
      default: null,
    },
    // 重置密码的权限
    resetPermissionCode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      /* 分页start */
      tab_info_length: 0,
      page: 1,
      perPage: 10,
      prePageOption: [10, 20, 30, 40, 50],
      pages: [],
      /* 分页end */
      config: {
        altFormat: "Y-m-d",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      date2: null,
      tableHeaders: [
        {
          name: 'role',
          label: this.$t('page.user.role'),
          visible: true
        },
        {
          name: 'username',
          label: this.$t('page.user.account'),
          visible: true
        },
        {
          name: 'name',
          label: this.$t('page.user.name'),
          visible: true
        },
        {
          name: 'email',
          label: this.$t('page.user.email'),
          visible: true
        },
        {
          name: 'tel',
          label: this.$t('page.user.contact number'),
          visible: true
        },
        {
          name: 'status',
          label: this.$t('page.user.status'),
          visible: true
        },
      ],
      loading: false,
      tableLoaded: false,
      dataList: [],
      count: 0,
      filters: {
        page: 1,
        page_size: 10,
        keyword: '',
        role_id: null,
        status: null,
        belong_id: this.belong_id,
        belong_type: this.belong_type,
      },
      filter_value: {
        keyword: '',
        role_id: null,
        status: null,
      },
      adding: false,
      editId: null,
      editIndex: null,
      addItem: {
        role_id: null,
        email: null,
        username: null,
        first_name: null,
        last_name: null,
        tel: null,
        belong_id: this.belong_id,
        belong_type: this.belong_type,
      },
      editItem: {},
      statusOptions: [
        { value: '1', label: this.$t('page.user.normal') },
        { value: '2', label: this.$t('page.user.freeze') },
      ]
    }
  },
  validations: {
    addItem: {
      role_id: { required },
      username: { required },
      first_name: { required },
      last_name: { required },
      tel: { required },
      email: { required, email },
    },
    editItem: {
      role_id: { required },
      first_name: { required },
      last_name: { required },
      tel: { required },
      email: { required, email },
    },
  },
  components: {
    editCustomer:localStorage.getItem("user")&&JSON.parse(localStorage.getItem("user")).user_type==='service_company'?serviceEditCustomer:editCustomer,
    addCustomer:localStorage.getItem("user")&&JSON.parse(localStorage.getItem("user")).user_type==='service_company'?serviceAddCustomer:addCustomer,
    Multiselect,
    tableLoading,
    RoleSelect,
  },
  computed: {
    getAccounts() {
      if (this.type === 'user') {
        return getUserAccounts
      } else {
        return getOrganizationAccounts
      }
    },
    createAccount() {
      if (this.type === 'user') {
        return createUserAccount
      } else {
        return createOrganizationAccount
      }
    },
    patchAccount() {
      if (this.type === 'user') {
        return patchUserAccount
      } else {
        return patchOrganizationAccount
      }
    },
    deleteAccount() {
      if (this.type === 'user') {
        return deleteUserAccount
      } else {
        return deleteOrganizationAccount
      }
    },
      user() {
        return JSON.parse(localStorage.getItem("user"));
      },

  },
  mounted() {
    this._getFirstPage()
  },

  methods: {
    // 新建
    add() {
      console.log(this.belong_type)
      this.$refs.addCustomer.open()
      for (let p in this.addItem) {
        if (['belong_id', 'belong_type'].includes(p)) {
          continue
        }
        this.addItem[p] = null
      }
      this.adding = true
      console.log('additem:',this.addItem)
    },
    // 保存添加
    addSave() {
      this.v$.addItem.$touch()
      if (this.v$.addItem.$invalid) {
        return
      }
      const params = _.cloneDeep(this.addItem)
      params.kc_account_id = new Date().getTime()
      this.createAccount(params).then(() => {
        this.$message.success(this.$t('base.add_success'))
        this._getFirstPage()
        this.$emit('added')
        this.adding = false
      }).catch(err => {
        console.log(err)
      })
    },
    // 冻结
    lock(item) {
      let is_active = !item.is_active
      alertComfirm(this.$t('base.Confirm to perform this operation?'),
          is_active ? this.$t('page.user.unfreeze_account') : this.$t('page.user.freeze_account')
      ).then(res => {
        if (res) {
          this.patchAccount({
            id: item.id,
            is_active: is_active
          }).then(() => {
            this._getFirstPage()
            this.$message.success(this.$t('base.operate_success'))
          })
        }
      })
    },
    // 重置密码
    resetPassword(id) {
      alertComfirm(this.$t('base.Confirm to perform this operation?'), this.$t('page.user.reset_password')).then(res => {
        if (res) {
          resetPassword(id).then(() => {
            this.$message.success(this.$t('base.operate_success'))
          })
        }
      })
    },
    // 编辑
    edit(item) {
      let province_id = []
      this.$refs.editCustomer.getProvince()
      console.log('editItem:', item)
      userAccountDetail(item.id).then(res=>{
        console.log(res)
        if(res.payload){
          if(res.payload.service_area.length>0){
            res.payload.service_area.map(item=>{
              province_id.push(item.province_id)
            })
          }

          this.editItem = {
            id: item.id,
            role_id: res.payload.role_id,
            email: res.payload.email,
            username: res.payload.username,
            first_name: res.payload.first_name,
            last_name: res.payload.last_name,
            tel: res.payload.tel,
            tags:res.payload.tags&&JSON.parse(res.payload.tags).length>0?JSON.parse(res.payload.tags):[],
            qualification: res.payload.qualification,
            service_area: res.payload.service_area,
            province_id: province_id

          }
        this.$nextTick(()=>{
          this.$refs.editCustomer.open()
          this.$refs.editCustomer.roleChange(item.role_id)

        })
        }

      })
    },
    // 取消编辑
    editCancel() {
      this.editItem = {}
      this.editId = null
      this.editIndex = null
    },
    // 保存编辑
    editSave() {
      this.v$.editItem.$touch()
      if (this.v$.editItem.$invalid) {
        return
      }
      const params = _.cloneDeep(this.editItem)
      delete params.username
      this.patchAccount(params).then(() => {
        this.$message.success(this.$t('base.modified_successfully'))
        // this.dataList[this.editIndex] = Object.assign(this.dataList[this.editIndex], this.editItem)
        this._getFirstPage()
        this.editId = null
        this.editIndex = null
        this.editItem = {}
      }).catch(err => {
        console.log(err)
      })
    },
    /* 设置分页选项 */
    setPages() {
      this.pages = [];
      this.tab_info_length = this.count;
      let numberOfPages = Math.ceil(this.count / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    // 筛选
    doFilter () {
      this.orders = []
      const search = {
        keyword: null,
        status: null,
        role_id: null,
        belong_id: this.belong_id,
        belong_type: this.belong_type,
      }
      if (this.filter_value.keyword) {
        search['keyword'] = this.filter_value.keyword
      }
      if (this.filter_value.role_id) {
        search['role_id'] = this.filter_value.role_id
      }
      if (this.filter_value.status !== null) {
        search['status'] = this.filter_value.status == 2 ? false : true
      }
      this.filters = _.assign(this.filters, search)
      this._getFirstPage()
    },
    // 重置
    resetSearch() {
      this.filter_value = {
        keyword: null,
        role_id: null,
        status: null,
      }
      this.$refs.roleFilter.clearSelect()
      this.doFilter()
    },
    // 翻页
    pageChange(val) {
      this.filters.page = val
      this._getList()
    },
    // 设置每页条数
    pageSizeChange(val) {
      this.filters.page_size = val
      this._getFirstPage()
    },
    // 获取数据
    _getFirstPage() {
      this.filters.page = 1;
      this._getList()
    },
    _getList() {
      this.dataList = []
      this.filters.page_size = this.perPage
      this.loading = true
      this.getAccounts(this.filters).then(res => {
        this.loading = false
        this.dataList = res.payload.results
        this.count = res.payload.count
        this.setPages()
      }).catch(err => {
        console.log(err)
      })
    },
    deleteItem(id) {
      alertComfirm().then(res => {
        if (res) {
          this.deleteAccount(id).then(res => {
            if (res.meta.code == 200) {
              this.$message.success(this.$t('base.delete_success'))
              this._getFirstPage()
            }
          })
        }
      })
    },
    getFieldText(item, fieldName) {
      let val = ''
      switch (fieldName) {
        case 'username':
          val = _.get(item, 'username', '')
          break;
        case 'role':
          val = _.get(item, 'role_name', '')
          break;
        case 'name':
          val = _.get(item, 'first_name', '') + ' ' + _.get(item, 'last_name', '')
          break;
        case 'tel':
          val = _.get(item, 'tel', '')
          break;
        case 'email':
          val = _.get(item, 'email', '')
          break;
        case 'status':
          val = _.get(item, 'is_active')
          break;
      }
      return val
    },

  },
};
</script>

<template>
  <div>
    <b-row>
      <b-col lg="12">
        <b-card no-body id="orderList">
          <!--    普通用户的筛选      -->
          <b-card-header v-if="type === 'user'" class="border-0">
            <b-row class="align-items-center gy-3">
              <b-col cols="sm">
                <h5 class="card-title mb-0">{{ $t('page.user.Account information') }}</h5>
              </b-col>
              <b-col sm="auto">
                <div class="d-flex gap-1 flex-wrap">

                  <b-button type="button" variant="primary" class="add-btn" @click="add" v-perm="postPermissionCode">
                    <i class="ri-add-line align-bottom me-1"></i> {{ $t('base.add') }}
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card-header>
          <b-card-body v-if="type === 'user'" class="border border-dashed border-end-0 border-start-0 mb-3">
            <b-form>
              <b-row class="g-3">
                <b-col xxl="4" >
                  <div class="search-box">
                    <input type="text" class="form-control search" v-model="filter_value.keyword" :placeholder="`${$t('page.user.account')}/${$t('page.user.name')}/${$t('page.user.contact number')}/${$t('page.user.email')}`" />
                    <i class="ri-search-line search-icon"></i>
                  </div>
                </b-col>
                <b-col xxl="3" >
                  <div class="input-light w-100 h-100">
                    <role-select class="w-100 h-100" ref="roleFilter" :type="type" :belong_type="belong_type" @changed="value => filter_value.role_id = value"></role-select>
                  </div>
                </b-col>
                <b-col xxl="3" >
                  <div class="input-light">
                    <Multiselect class="form-control" :placeholder="$t('page.user.Select status')" v-model="filter_value.status" :close-on-select="true" :searchable="false"
                                 :create-option="false" :options="statusOptions" :can-clear="false" />
                  </div>
                </b-col>
                <b-col xxl="2"  class="d-flex justify-content-end align-items-end ">
                    <b-button type="button" variant="primary" class="me-2" @click="doFilter">
                      <i class="ri-search-line me-1 align-bottom"></i>
                      {{ $t('search') }}
                    </b-button>
                    <b-button
                        type="button"
                        variant="info"
                        @click="resetSearch"
                    >
                      <i class="ri-restart-line me-1 align-bottom"></i>
                      {{ $t('base.reset') }}
                    </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
          <!--    企业用户的筛选      -->
          <b-card-body v-if="type === 'organization'" class="border border-dashed border-top-0 border-end-0 border-start-0 mb-3">
            <b-form>
              <b-row class="g-3">
                <b-col>
                  <div class="search-box">
                    <input type="text" class="form-control search" v-model="filter_value.keyword"
                           :placeholder="`${$t('page.user.account')}/${$t('page.user.name')}/${$t('page.user.contact number')}/${$t('page.user.email')}`" />
                    <i class="ri-search-line search-icon"></i>
                  </div>
                </b-col>
                <b-col cols="12" md="auto" class="d-flex justify-content-end align-items-end">
                    <b-button type="button" variant="primary" @click="doFilter" class="me-3">
                      <i class="ri-search-line me-1 align-bottom"></i>
                      {{ $t('search') }}
                    </b-button>
                    <b-button type="button" variant="primary" class="add-btn" @click="add" v-perm="postPermissionCode">
                      <i class="ri-add-line align-bottom me-1"></i> {{ $t('base.add') }}
                    </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
          <!--    账户列表      -->
          <b-card-body class="pt-0">
            <div>
              <div class="table-responsive table-card mb-1">
                <table class="table table-nowrap align-middle" id="orderTable">
                  <thead class="text-muted table-light">
                  <tr class="text-uppercase">
                    <template v-for="(item, index) in tableHeaders" :key="index">
                      <th v-show="item.visible">{{ item.label }}</th>
                    </template>
                    <th class="text-end" style="padding-right: 70px;">
                      {{ $t('base.operation') }}
                    </th>
                  </tr>
                  </thead>
                  <tbody class="list form-check-all">
                 <!-- <tr v-if="adding">
                    <td class="td-min-w">
                      <role-select :placeholder="$t('base.required')" :type="type" :belong_type="belong_type" @changed="value => addItem.role_id = value" :invalid="!!v$.addItem.role_id.$errors.length"></role-select>
                    </td>
                    <td>
                      <input type="text" class="form-control" :class="v$.addItem.username.$errors.length ? 'is-invalid' : ''"  v-model="addItem.username" :placeholder="$t('base.required')" />
                    </td>
                    <td class="td-min-w">
                      <div class="d-flex justify-content-between">
                        <input type="text" class="form-control me-2" :class="v$.addItem.first_name.$errors.length ? 'is-invalid' : ''" :placeholder="$t('also.last name')" v-model="addItem.first_name" />
                        <input type="text" class="form-control me-2" :class="v$.addItem.last_name.$errors.length ? 'is-invalid' : ''" :placeholder="$t('also.first name')" v-model="addItem.last_name" />
                      </div>
                    </td>
                    <td>
                      <input type="text" class="form-control" :class="v$.addItem.email.$errors.length ? 'is-invalid' : ''"  :placeholder="$t('base.required')" v-model="addItem.email" />
                    </td>
                    <td>
                      <input type="text" class="form-control" :class="v$.addItem.tel.$errors.length ? 'is-invalid' : ''"  :placeholder="$t('base.required')" v-model="addItem.tel" />
                    </td>
                    <td></td>
                    <td class="text-end">
                      <i class="ri-checkbox-circle-line me-3 text-primary fs-2 cursor-pointer" @click="addSave"></i>
                      <i class="ri-close-circle-line me-3 text-danger fs-2 cursor-pointer" @click="adding = false"></i>
                    </td>
                  </tr>-->
                  <tr v-for="(item, index) in dataList" :key="index">
                    <template v-for="(titleItem, titleIdx) in tableHeaders" :key="titleIdx">
                      <td v-show="titleItem.visible" :class="['type','name'].includes(titleItem.name) ? 'td-min-w' : ''">
                        <!--        显示            -->
                        <template v-if="editId != item.id">
                          <template v-if="titleItem.name === 'status'">
                            <span v-if="getFieldText(item, 'status')" class="badge badge-soft-success">{{ $t('page.user.normal') }}</span>
                            <span v-else class="badge badge-soft-danger">{{ $t('page.user.freeze') }}</span>
                          </template>
                          <span v-else>{{ getFieldText(item, titleItem.name) }}</span>
                        </template>
                        <!--         编辑           -->
                        <template v-else>
                          <input v-if="titleItem.name == 'username'" type="text" class="form-control" placeholder="" v-model="editItem.username" disabled />
                          <role-select v-if="titleItem.name == 'role'" :type="type" :belong_type="belong_type" :placeholder="$t('base.required')" :invalid="!!v$.editItem.role_id.$errors.length" :value="editItem.role_id" @changed="value => editItem.role_id = value"></role-select>
                          <div v-if="titleItem.name == 'name'" class="d-flex justify-content-between">
                            <input type="text" class="form-control me-2" :class="v$.editItem.first_name.$errors.length ? 'is-invalid' : ''" :placeholder="$t('also.last name')" v-model="editItem.first_name" />
                            <input type="text" class="form-control me-2" :class="v$.editItem.last_name.$errors.length ? 'is-invalid' : ''" :placeholder="$t('also.first name')" v-model="editItem.last_name" />
                          </div>
                          <input v-if="titleItem.name == 'tel'" type="text" class="form-control" :class="v$.editItem.tel.$errors.length ? 'is-invalid' : ''" :placeholder="$t('base.required')" v-model="editItem.tel" />
                          <input v-if="titleItem.name == 'email'" type="text" class="form-control" :class="v$.editItem.email.$errors.length ? 'is-invalid' : ''" :placeholder="$t('base.required')" v-model="editItem.email" />
                        </template>
                      </td>
                    </template>
                    <!--          操作          -->
                    <td class="text-end" v-if="editId != item.id">
                      <i class="ri-edit-2-line fs-3 text-primary me-3 cursor-pointer" @click="edit(item, index)" ></i>
                      <i class="ri-lock-line fs-3 text-primary me-3 cursor-pointer" v-if="item.is_active" @click="lock(item, index)" v-perm="freezePermissionCode"></i>
                      <i class="ri-lock-unlock-line fs-3 text-primary me-3 cursor-pointer" v-if="!item.is_active" @click="lock(item, index)" v-perm="freezePermissionCode"></i>
                      <i class="ri-key-2-line fs-3 text-primary me-3 cursor-pointer" v-perm="resetPermissionCode" @click="resetPassword(item.id)"></i>
                      <!--<i class="ri-delete-bin-line fs-3 text-primary me-3 cursor-pointer" @click="deleteItem(item.id)"></i>-->
                    </td>
                    <td class="text-end" v-else>
                      <i class="ri-checkbox-circle-line me-3 text-primary fs-2 cursor-pointer" @click="editSave"></i>
                      <i class="ri-close-circle-line me-3 text-danger fs-2 cursor-pointer" @click="editCancel"></i>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table-loading :count="count" :table-loading="loading" :table-loaded="!loading"></table-loading>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <Pagination
        v-if="tab_info_length"
        v-model:page="page"
        v-model:perPage="perPage"
        :pages="pages"
        :prePageOption="prePageOption"
        :tab_info_length="tab_info_length"
        @update:page="pageChange"
        @update:perPage="pageSizeChange"
        class="me-5 my-3"
    ></Pagination>
    <add-customer ref="addCustomer" @refresh="_getFirstPage"></add-customer>
    <edit-customer ref="editCustomer" @refresh="_getList" :editItem="editItem"></edit-customer>

  </div>

</template>
<style scoped>
.td-min-w {
  min-width: 220px;
}
</style>
